export enum TaskStatus {
    Draft = 'draft',
    Ready = 'ready',
    Deprecated = 'deprecated',
    Updating = 'updating',
}

export enum TaskExecutionStatus {
    Draft = 'draft',
    Queued = 'queued',
    Running = 'running',
    Failed = 'failed',
    Cancelled = 'cancelled',
    Completed = 'completed',
    Ready = 'ready',
    Deprecated = 'deprecated',
    Updating = 'updating',
}

export type TaskType = 'harvester' | 'mapping' | 'cleaning' | 'encryption' | 'anonymisation' | 'loader';

/**
 * User-facing labels for the pipeline steps. The `TaskType` values are part of the API
 * contract and must not change, so the displayed terminology lives here.
 */
export const taskTypeLabels: Record<TaskType, string> = {
    harvester: 'Data Ingestion',
    mapping: 'Data Harmonisation',
    cleaning: 'Data Quality',
    encryption: 'Encryption',
    anonymisation: 'Anonymisation',
    loader: 'Storage',
};

/**
 * Resolves the user-facing label of a pipeline step, given either its `TaskType` or its
 * (case-insensitive) display name as returned by the API. Unknown values are returned as-is.
 */
export const taskLabelFor = (value: string): string => taskTypeLabels[value.toLowerCase() as TaskType] ?? value;
